// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingParticipantEntity from './entities/hearing-participant.json';
import hearingParticipantMenu from '../pages/hearing-participant/menu.json';
import hearingParticipantFullForm from '../pages/hearing-participant/forms/full.json';
import hearingParticipantContextForm from '../pages/hearing-participant/forms/context.json';
import hearingParticipantMiniForm from '../pages/hearing-participant/forms/mini.json';
import hearingParticipantLookupForm from '../pages/hearing-participant/forms/lookup.json';
import hearingParticipantTableView from '../pages/hearing-participant/views/table.json';
import hearingParticipantCardsView from '../pages/hearing-participant/views/cards.json';
import hearingParticipantCalendarView from '../pages/hearing-participant/views/calendar.json';
import hearingParticipantDashboardView from '../pages/hearing-participant/views/dashboard.json';

/** Тип запису «Учасник слухань» зі сторінками пакета: меню, форми та подання з pages/hearing-participant/. */
export const hearingParticipantDefinition: IRecordTypeDefinition = {
  ...hearingParticipantEntity,
  views: assembleViewSet({
      table: hearingParticipantTableView,
      cards: hearingParticipantCardsView,
      calendar: hearingParticipantCalendarView,
      dashboard: hearingParticipantDashboardView,
  }),
  form: hearingParticipantFullForm,
  forms: { full: hearingParticipantFullForm, context: hearingParticipantContextForm, mini: hearingParticipantMiniForm, lookup: hearingParticipantLookupForm },
  menu: hearingParticipantMenu,
} as IRecordTypeDefinition;
